import { schemaUpgrade } from "./schemaFix";

export function saveDataToLocalStorage(key: string, data: any) {
  localStorage.setItem(key, JSON.stringify(data));
}

export function getAllDataFromStorage() {
  const fullJsonData = retrieveDataFromLocalStorage('fullJsonData');

  //if the schema version in localstorage is outdated, upgrade it.
  let outJson = fullJsonData;
  if(fullJsonData) {
    // What do to for fetching schema for validation?
    outJson = schemaUpgrade(fullJsonData, {"noSchema":true})
  };

  return structuredClone({...outJson});
}

export function retrieveDataFromLocalStorage(key: string) {
  try {
  
    const data = localStorage.getItem(key) ?? "undefined";
    if (data !== "undefined") {
      return JSON.parse(data);
    } else {
      return null;
    }
  } catch (e) {
    console.error(e);
    return null;
  }
}

export function removeDataFromLocalStorage() {
  console.log('Before clear - localStorage length:', localStorage.length);
  console.log('Before clear - keys:', Object.keys(localStorage));
  
  localStorage.clear();
  
  console.log('After clear - localStorage length:', localStorage.length);
  console.log('After clear - keys:', Object.keys(localStorage));
  
  // Add a small delay to see if anything gets re-added immediately
  setTimeout(() => {
    console.log('After 100ms - localStorage length:', localStorage.length);
    console.log('After 100ms - keys:', Object.keys(localStorage));
  }, 100);
}